import { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('user');
        try {
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (e) {
            console.error('Error parsing user from localStorage:', e);
            return null;
        }
    });

    const [accessToken, setAccessToken] = useState(() => {
        return localStorage.getItem('accessToken') || Cookies.get('accessToken') || null;
    });

    const [company, setCompany] = useState(() => {
        const storedCompany = localStorage.getItem('company');
        try {
            return storedCompany ? JSON.parse(storedCompany) : null;
        } catch (e) {
            console.error('Error parsing company from localStorage:', e);
            return null;
        }
    });

    const [role, setRole] = useState(() => {
        return localStorage.getItem('role') || Cookies.get('role') || null;
    });
    const [visibility, setvisibility] = useState(() => {
        const storedVisibility = localStorage.getItem('visibility');
        try {
            return storedVisibility ? JSON.parse(storedVisibility) : null;
        } catch (e) {
            console.error('Error parsing visibility from localStorage:', e);
            return null;
        }
    });

    useEffect(() => {
        if (accessToken) Cookies.set('accessToken', accessToken, { expires: 7, secure: true, sameSite: 'Strict' });
        if (user) Cookies.set('user', JSON.stringify(user), { expires: 7, secure: true, sameSite: 'Strict' });
        if (company) Cookies.set('company', JSON.stringify(company), { expires: 7, secure: true, sameSite: 'Strict' });
        if (role) Cookies.set('role', role, { expires: 7, secure: true, sameSite: 'Strict' });
        if (visibility) Cookies.set('visibility', JSON.stringify(visibility), { expires: 7, secure: true, sameSite: 'Strict' });
    }, [user, accessToken, company, role, visibility]);

    const login = (userData, token, companyData, role, visibility) => {
        setUser(userData);
        setAccessToken(token);
        setCompany(companyData);
        setRole(role);
        setvisibility(visibility);

        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('accessToken', token);
        localStorage.setItem('company', JSON.stringify(companyData));
        localStorage.setItem('visibility', JSON.stringify(visibility));
        localStorage.setItem('role', role);

        Cookies.set('user', JSON.stringify(userData), { expires: 7, secure: true, sameSite: 'Strict' });
        Cookies.set('accessToken', token, { expires: 7, secure: true, sameSite: 'Strict' });
        Cookies.set('company', JSON.stringify(companyData), { expires: 7, secure: true, sameSite: 'Strict' });
        Cookies.set('visibility', JSON.stringify(visibility), { expires: 7, secure: true, sameSite: 'Strict' });
        Cookies.set('role', role, { expires: 7, secure: true, sameSite: 'Strict' });
    };

    const logout = () => {
        setUser(null);
        setAccessToken(null);
        setCompany(null);
        setRole(null);
        setvisibility(null);

        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('company');
        localStorage.removeItem('role');
        localStorage.removeItem('visibility');
        localStorage.removeItem('bubbleSettings');
        localStorage.removeItem('globalSettings');
        localStorage.removeItem('hasSearched');

        Cookies.remove('user');
        Cookies.remove('accessToken');
        Cookies.remove('company');
        Cookies.remove('role');
        Cookies.remove('visibility');
        Cookies.remove('bubbleSettings');
        Cookies.remove('globalSettings');
        Cookies.remove('hasSearched');
    };

    return (
        <AuthContext.Provider value={{ user, company, setCompany, role, accessToken, login, logout, visibility, setvisibility }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);